import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../config/api';
import axios from 'axios';
import withAuthorization from "../components/authentication";
import { numberToWordsIndian } from '../utils/numberToWords';
import Navbar from '../components/Navbar';
import { openAndSaveInvoice } from '../utils/openAndSaveInvoice';
const DummyTokenForm = () => {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [formData, setFormData] = useState({
    carTitle: '',
    carModel: '',
    customerName: '',
    customerMobile: '',
    whatsappMobile: '',
    customerAddress: '',
    customerEmail: '',
    tokenAmount: '',
    dateOfPaymentReceived:'',
    paymentMode: '',
    paymentTo: '',
    dealDoneAmount: '',
    fairMarketValue: '',
    carRegistrationNumber: '',
    loanOrCash: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  
    const [showModal, setShowModal] = useState(false);

  // The invoice number is assigned by the backend from an atomic per-financial-year
  // counter, so the old count-fetching endpoints are no longer needed here.
  




  // Invoice PDF is generated entirely in the backend (Car-Swipe-Backend/g/invoices).

  //count invoice from backend
  // Function to fetch token count from the backend

  

  const [loading, setLoading] = useState(false);

  // Blocks duplicate submissions; reset automatically when loading clears.
  const submittingRef = useRef(false);
  useEffect(() => {
    if (!loading) submittingRef.current = false;
  }, [loading]);

  const handleSubmit = async (e) => {
    // Synchronous guard: blocks a second click in the same tick, which a
    // state check cannot do. Prevents duplicate invoices.
    if (submittingRef.current) return;
    submittingRef.current = true;
    setLoading(true);
   
    
    try {
      // Send ONLY JSON data. The backend generates the invoice PDF, assigns the
      // invoice number and returns a short-lived viewing URL.
      const response = await axios.post(
        `${API_BASE_URL}/dummytoken/submit-dummytoken`,
        formData,
        { withCredentials: true }
      );

      // Open the invoice in a new tab and save a copy to disk.

      openAndSaveInvoice(response.data);

      setSubmissionSuccess(true);
    } catch (error) {
      console.error('Error submitting token:', error.response?.data || error.message);
      alert('Failed to submit the token application. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  

  

  return (
    <div><Navbar/><div className="container mx-auto my-10 p-5 border border-gray-300 rounded-lg shadow-lg">
    <h1 className="text-2xl font-bold mb-5">Dummy Token Form</h1>
    <form >
      <div className="relative w-full p-4 border border-blue-700 rounded">
      <div className="mb-4">
        <label className="block text-gray-700">Car Title</label>
        <input
          type="text"
          name="carTitle"
          value={formData.carTitle}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Car Model</label>
        <input
          type="text"
          name="carModel"
          value={formData.carModel}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
     
      <div className="mb-4">
        <label className="block text-gray-700">Customer Name</label>
        <input
          type="text"
          name="customerName"
          value={formData.customerName}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Customer Mobile</label>
        <input
          type="text"
          name="customerMobile"
          value={formData.customerMobile}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">WhatsApp Mobile</label>
        <input
          type="text"
          name="whatsappMobile"
          value={formData.whatsappMobile}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Customer Address</label>
        <input
          type="text"
          name="customerAddress"
          value={formData.customerAddress}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Customer Email (Optional)</label>
        <input
          type="email"
          name="customerEmail"
          value={formData.customerEmail}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      </div>
      <div className="relative w-full p-4 border border-red-700 rounded">
      <div className="mb-4">
        <label className="block text-gray-700">Token Amount</label>
        <input
          type="number"
          name="tokenAmount"
          value={formData.tokenAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Token Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="Token Amount in Words"
          value={numberToWordsIndian(`${formData.tokenAmount}`)}
         
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
      <label className="block text-gray-700">Date of Token Received in Bank/Cash</label>
      <input
type="date"
name="dateOfPaymentReceived" // Name should match the key in your state object
value={formData.dateOfPaymentReceived} // Use formData to populate the value
onChange={handleChange} // Call the handleChange function when the date changes
className="border rounded px-2 py-1"
/></div>

      <div className="mb-4">
        <label className="block text-gray-700">Payment Mode</label>
        <select
          name="paymentMode"
          value={formData.paymentMode}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        >
          <option value="">Select Payment Mode</option>
          <option value="Cash">Cash</option>
          <option value="Personal Account">Personal Account</option>
          <option value="Company Account">Company Account</option>
        </select>
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Payment To</label>
        <select
          name="paymentTo"
          value={formData.paymentTo}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        >
          <option value="">Select Payment To</option>
          <option value="Piyush">Piyush</option>
          <option value="Ramesh">Ramesh</option>
          <option value="Omprakash">Omprakash</option>
        </select>
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Deal Done Amount</label>
        <input
          type="number"
          name="dealDoneAmount"
          value={formData.dealDoneAmount}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Deal Amount <strong>in Words</strong> </label>
        <input
          type="text"
          name="Token Amount in Words"
          value={numberToWordsIndian(`${formData.dealDoneAmount}`)}
         
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Fair Market Value</label>
        <input
          type="number"
          name="fairMarketValue"
          value={formData.fairMarketValue}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Fair Market Value <strong>in Words</strong></label>
        <input
          type="text"
          name="fairMarketValueinwords"
          value={numberToWordsIndian(`${formData.fairMarketValue}`)}
          
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      </div>
      <div className="relative w-full p-4 border border-green-700 rounded">
      <div className="mb-4">
        <label className="block text-gray-700">Car Registration Number</label>
        <input
          type="text"
          name="carRegistrationNumber"
          value={formData.carRegistrationNumber}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700">Loan or Cash</label>
        <select
          name="loanOrCash"
          value={formData.loanOrCash}
          onChange={handleChange}
          required
          className="w-full p-2 border border-gray-300 rounded mt-2"
        >
          <option value="">Select Loan or Cash</option>
          <option value="Loan">Loan</option>
          <option value="Cash">Cash</option>
        </select>
      </div>
      </div>
      
      
      
      <div>
      <button  onClick={() => setShowModal(true)}
        type="button"
        className="w-full p-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition mt-5"
      >
       Preview Form
      </button>
      
    </div>
    </form>
    {submissionSuccess && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
            <h2 className="text-xl font-semibold text-green-600">Token Invoice is downloded Successfully!</h2>
            <p className="mt-2 text-gray-700">THANK YOU.</p>
            <button
              onClick={() => setSubmissionSuccess(false)}
              className="mt-4 px-6 py-2 bg-blue-500 text
              white rounded-lg hover:bg-blue-600 transition"
            >
            Close
            </button>
          </div>
        </div>
      )}

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white w-[95%] max-w-3xl p-6 rounded-2xl shadow-2xl overflow-y-auto max-h-[95vh] border border-black relative">
      
            {/* Header with title and edit button */}
            <div className="flex justify-between items-center mb-6 border-b pb-4">
              <h2 className="text-2xl font-bold text-gray-800">Form Preview</h2>
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="bg-blue-600 text-white px-4 py-2 text-sm rounded hover:bg-blue-700 transition"
              >
                Edit Form
              </button>
            </div>
      
            {/* Data Section */}
            <div className="space-y-4 text-md text-gray-800">
              <p><strong>Car Title :</strong> {formData.carTitle}</p>
              <p><strong>Car Model :</strong> {formData.carModel}</p>
              <p><strong>Customer Name :</strong> {formData.customerName}</p>
              <p><strong>Customer Mobile :</strong> {formData.customerMobile}</p>
              <p><strong>Whatsapp Mobile :</strong> {formData.whatsappMobile}</p>
              <p><strong>Customer Address :</strong> {formData.customerAddress}</p>
              <p><strong>Customer Email :</strong> {formData.customerEmail}</p>
              <p><strong>Token Amount :</strong> ₹{formData.tokenAmount}</p>
              <p className="text-indigo-600 font-medium">
                <strong className="text-gray-800">Token Amount in Words :</strong>{' '} {numberToWordsIndian(`${formData.tokenAmount}`)}
              </p>
              <p><strong>Payment Mode :</strong> {formData.paymentMode}</p>
              <p><strong>Payment To :</strong> {formData.paymentTo}</p>
              <p><strong>Deal Done Amount :</strong> ₹{formData.dealDoneAmount}</p>
              <p className="text-indigo-600 font-medium">
              <strong className="text-gray-800">Deal Done Amount in Words :</strong>{' '}
              {numberToWordsIndian(`${formData.dealDoneAmount}`)}
            </p>
            
              <p><strong>Fair Market Value :</strong> ₹{formData.fairMarketValue}</p>
              <p className="text-indigo-600 font-medium">
                <strong className="text-gray-800">Fair Market Value in Words :</strong>{' '} {numberToWordsIndian(`${formData.fairMarketValue}`)}
              </p>
              <p><strong>Car Registration Number :</strong> {formData.carRegistrationNumber}</p>
              <p><strong>Loan or Cash :</strong> {formData.loanOrCash}</p>
              
            </div>
      
            {/* Submit Button */}
            <div className="flex justify-end mt-8">
              <button
                type="button"
                disabled={loading}
                onClick={(e) => {
                  e.preventDefault(); 
                  setShowModal(false);
                  handleSubmit();
                }}
                className="bg-green-600 text-white w-full py-2 rounded-lg hover:bg-green-700 transition"
              >
              {loading ? (
                <div className="flex flex-col items-center justify-center h-screen bg-white">
  {/* Car Animation Container */}
  <div className="relative w-28 h-28 flex items-center justify-center">
    {/* Moving Car Icon */}
    <img
      src="https://res.cloudinary.com/dztz5ltuq/image/upload/v1754381777/Screenshot__620_-removebg-preview_20250805_134123_0000_2_gbdz3h.png"
      alt="Car Logo"
      className="w-36 h-16 animate-carDrive"
    />
  </div>

  {/* Text Section */}
  <p className="mt-0 text-xl md:text-2xl font-bold text-gray-800 text-center">
   Token Form is submitting Please Wait ...
   
  </p>
 
</div>
              ) : (
                'Submit Token Form'
              )}
              </button>
            </div>
      
          </div>
        </div>
      )
      
                }

  </div></div>
  );
};

export default   withAuthorization(DummyTokenForm, ["admin", "Employee"]);
